import React from 'react'
import Styled from 'styled-components'

import Logo from './logo'
import Menu from './menu'
import ProductsList from './products-list'
import SiteActions from '../../actions/site-actions';

class Header extends React.Component {

    constructor(props) {
        super(props)
    }

    toggleMenu() {
        SiteActions.toggleMenu()
    }

    render() {
        const { siteTitle } = this.props
        return (
            <HeaderWrapper>
                <Logo siteTitle={siteTitle} />
                <Toggle onClick={this.toggleMenu.bind(this)} >
                    <svg data-v-0442e2cc="" aria-hidden="true" className="svg-inline--fa fa-bars fa-w-14" data-icon="bars" data-prefix="fas" role="img" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path data-v-0442e2cc="" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" fill="currentColor" className=""></path></svg>
                </Toggle>
                <ProductsList siteTitle={siteTitle} />
                <Menu />
            </HeaderWrapper>
        )
    }
}

export default Header

const HeaderWrapper = Styled.header`
    display: flex;
    padding: 20px 0;
    position: fixed;
    background: #fff;
    z-index: 1040;
    width: 100%;
    max-height: 70px;
    box-shadow: 3px 0 30px rgba(17,31,93,.08),
                2px 0 5px rgba(27,27,43,.09);
`

const Toggle = Styled.div`
    display: none;
    position: relative;
    left: 20px;
    top: 3px;
    padding: 0 10px;
    color: #8a93a5;

    @media (max-width: 780px) {
        display: block;
    }
`
